import axios from 'axios'

const newAxios = axios.create({
  baseURL: window.g.baseUrl,
  withCredentials: true
})

/**
 * 设置axios实例的拦截器
 */
newAxios.interceptors.response.use(
  (res) => {
    // status为服务器连接状态，res.data.code为服务器返回的code，200为成功
    if (res.status === 200 && res.data.code === 200) {
      return Promise.resolve(res.data.data)
    }
    const errMsg = res.data ? res.data.message : '服务器错误'
    return Promise.reject(errMsg)
  },
  (err) => {
    console.dir(err)
    return Promise.reject(err)
  }
)

export default newAxios
